




























































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { MutationTypes } from '@/store/mutations'
import { line } from 'd3-shape'
import { scaleLinear, scaleTime } from 'd3-scale'
import { humanDate, filterFunc, getDisastersColor } from '@/lib/common'
import { DayData, DisasterDatum, TSDatum } from '@/lib/types'
import { locales } from '@/lib/labels'

import { select } from 'd3-selection'
import { timeFormatDefaultLocale, timeFormat } from 'd3-time-format'
import { axisBottom, axisLeft } from 'd3-axis'

@Component({
	name: 'SeasonDetail',
	components: {}
})
export default class TimeSelector extends Vue {
	readonly humanDate = humanDate

	get cloudBlobDisastersOnly() {
		return this.$tStore.state.disasterFilter.cloudBandOnly
	}

	get season() {
		if (this.$tStore.state.selectedSeasonIndex === null) {
			return this.$tStore.getters.seasons[0]
		}
		return this.$tStore.getters.seasons[this.$tStore.state.selectedSeasonIndex]
	}

	get cloudData() {
		return this.$tStore.state.cloudData
	}

	get selectedSeasonIndex() {
		return this.$tStore.state.selectedSeasonIndex || 0
	}

	get selectedEventIndex() {
		return this.$tStore.state.selectedEventIndex
	}

	get daysOfYear() {
		const days = []
		for (let i = 1; i <= 366; i++) {
			days.push(i)
		}
		return days
	}

	get seasonDays() {
		if (!this.season) {
			return []
		}
		return this.season.days
	}

	dayHasDisasters(disasters: DisasterDatum[] | undefined) {
		if (!disasters) return false
		return (
			disasters.filter(d => filterFunc(d, this.$tStore.state.disasterFilter))
				.length > 0
		)
	}

	dayHasMajorDisasters(disasters: DisasterDatum[] | undefined) {
		if (!disasters) return false
		return disasters.filter(d => d.major).length > 0
	}

	getDisasterColor(disasters: DisasterDatum[] | undefined) {
		if (!disasters) return 'rgba(0,0,0,0)'
		return getDisastersColor(
			disasters.filter(d => filterFunc(d, this.$tStore.state.disasterFilter))
		)
	}

	// Found with the below code in chartPath(), but there's no point in calculating it each time
	// while the data is not going to change.
	// const dataMax = Math.max(...this.$tStore.state.tsData.map(d => d.rain))
	readonly dataMax = 13.5
	get chartPath() {
		if (!this.season || this.$tStore.state.tsData === null) return ''
		const startDate = this.season.days[0].date
		const endDate = this.season.days[this.season.days.length - 1].date
		const data = this.$tStore.state.tsData.filter(
			d =>
				d.date.getTime() >= startDate.getTime() &&
				d.date.getTime() <= endDate.getTime()
		)
		const xScale = scaleTime([startDate, endDate], [0, 100])
		const yScale = scaleLinear([0, this.dataMax], [100, 0])
		const lineGen = line()
			// @ts-ignore
			.x((d: TSDatum) => xScale(d.date))
			// @ts-ignore
			.y((d: TSDatum) => yScale(d.rain))
		// @ts-ignore
		return lineGen(data)
	}

	selectEvent(day: DayData) {
		if (!day.cloudBlobIndex) return
		this.$tStore.commit(MutationTypes.SET_SELECTED_EVENT, {
			fcIndex: day.cloudBlobIndex.fcIndex,
			color: day.color
		})
		this.$tStore.commit(MutationTypes.SET_SELECTED_VIEW, 'map')
	}

	get isFirstSeason() {
		return this.selectedSeasonIndex === 0
	}

	get isLastSeason() {
		return this.selectedSeasonIndex === this.$tStore.getters.seasons.length - 1
	}

	nextSeason() {
		if (!this.isLastSeason) {
			this.$tStore.commit(
				MutationTypes.SET_SELECTED_SEASON,
				this.selectedSeasonIndex + 1
			)
			this.redrawAxes()
		}
	}

	prevSeason() {
		if (!this.isFirstSeason) {
			this.$tStore.commit(
				MutationTypes.SET_SELECTED_SEASON,
				this.selectedSeasonIndex - 1
			)
			this.redrawAxes()
		}
	}

	axisWidth: number = 0
	axisHeight: number = 0
	setSizes() {
		if (this.$refs.dayaxis) {
			// @ts-ignore
			let rect = this.$refs.dayaxis.getBoundingClientRect()
			this.axisWidth = rect.width
		}
		if (this.$refs.rainaxis) {
			// @ts-ignore
			let rect = this.$refs.rainaxis.getBoundingClientRect()
			this.axisHeight = rect.height
		}
		this.redrawAxes()
	}

	@Watch('$tStore.state.language')
	redrawAxes() {
		if (this.season !== null && this.season !== undefined) {
			const startDate = this.season.days[0].date
			const endDate = this.season.days[this.season.days.length - 1].date
			const xScale = scaleTime([startDate, endDate], [0, this.axisWidth])

			timeFormatDefaultLocale(locales[this.$lang])
			const xAxis = axisBottom(xScale).tickFormat(timeFormat('%B'))

			select('#days-axis svg g')
				.selectAll('*')
				.remove()
			select('#days-axis svg g').call(xAxis)

			const yScale = scaleLinear([0, this.dataMax], [this.axisHeight, 0])
			const yAxis = axisLeft(yScale)

			select('#rain-axis svg g')
				.selectAll('*')
				.remove()
			select('#rain-axis svg g')
				.attr('transform', 'translate(50,0)')
				.call(yAxis)
		}
	}

	mounted() {
		select('#days-axis svg').append('g')
		select('#rain-axis svg').append('g')
		this.setSizes()

		window.addEventListener('resize', this.setSizes)
	}
}
